import axios from "axios";

// Same-origin API: works identically on preview URL, emergent.host and the custom domain.
// Falls back to REACT_APP_BACKEND_URL only for local development.
const HOST = typeof window !== "undefined" ? window.location.hostname : "";
const BASE =
  HOST === "localhost" || HOST === "127.0.0.1" || HOST === ""
    ? process.env.REACT_APP_BACKEND_URL
    : window.location.origin;

export const API = `${BASE}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiError(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function fileUrl(storagePath) {
  return `${API}/files/${storagePath}`;
}

export default api;
